module.exports = __webpack_public_path__ + "assets/images/lapin-sketching-7281159f13095156e5c14983c442765b.png";